__turbopack_context__.v({
  "activeNode": "CareerProgressionTimeline-module__HazpYW__activeNode",
  "activeSalaryBar": "CareerProgressionTimeline-module__HazpYW__activeSalaryBar",
  "alternativeCard": "CareerProgressionTimeline-module__HazpYW__alternativeCard",
  "alternativeDescription": "CareerProgressionTimeline-module__HazpYW__alternativeDescription",
  "alternativeFrom": "CareerProgressionTimeline-module__HazpYW__alternativeFrom",
  "alternativeHeader": "CareerProgressionTimeline-module__HazpYW__alternativeHeader",
  "alternativeRequirements": "CareerProgressionTimeline-module__HazpYW__alternativeRequirements",
  "alternativeSection": "CareerProgressionTimeline-module__HazpYW__alternativeSection",
  "alternativeTitle": "CareerProgressionTimeline-module__HazpYW__alternativeTitle",
  "alternativeToggle": "CareerProgressionTimeline-module__HazpYW__alternativeToggle",
  "alternativesList": "CareerProgressionTimeline-module__HazpYW__alternativesList",
  "certTag": "CareerProgressionTimeline-module__HazpYW__certTag",
  "certTags": "CareerProgressionTimeline-module__HazpYW__certTags",
  "clockIcon": "CareerProgressionTimeline-module__HazpYW__clockIcon",
  "container": "CareerProgressionTimeline-module__HazpYW__container",
  "detailSection": "CareerProgressionTimeline-module__HazpYW__detailSection",
  "growthTipsList": "CareerProgressionTimeline-module__HazpYW__growthTipsList",
  "growthTipsSection": "CareerProgressionTimeline-module__HazpYW__growthTipsSection",
  "header": "CareerProgressionTimeline-module__HazpYW__header",
  "headerContent": "CareerProgressionTimeline-module__HazpYW__headerContent",
  "headerIcon": "CareerProgressionTimeline-module__HazpYW__headerIcon",
  "levelBadge": "CareerProgressionTimeline-module__HazpYW__levelBadge",
  "levelDetails": "CareerProgressionTimeline-module__HazpYW__levelDetails",
  "levelHeader": "CareerProgressionTimeline-module__HazpYW__levelHeader",
  "levelMeta": "CareerProgressionTimeline-module__HazpYW__levelMeta",
  "levelNavigation": "CareerProgressionTimeline-module__HazpYW__levelNavigation",
  "levelSalary": "CareerProgressionTimeline-module__HazpYW__levelSalary",
  "levelYears": "CareerProgressionTimeline-module__HazpYW__levelYears",
  "milestoneCard": "CareerProgressionTimeline-module__HazpYW__milestoneCard",
  "milestoneContent": "CareerProgressionTimeline-module__HazpYW__milestoneContent",
  "milestoneDescription": "CareerProgressionTimeline-module__HazpYW__milestoneDescription",
  "milestoneIcon": "CareerProgressionTimeline-module__HazpYW__milestoneIcon",
  "milestoneTiming": "CareerProgressionTimeline-module__HazpYW__milestoneTiming",
  "milestoneTitle": "CareerProgressionTimeline-module__HazpYW__milestoneTitle",
  "milestonesList": "CareerProgressionTimeline-module__HazpYW__milestonesList",
  "milestonesSection": "CareerProgressionTimeline-module__HazpYW__milestonesSection",
  "navButton": "CareerProgressionTimeline-module__HazpYW__navButton",
  "nodeCircle": "CareerProgressionTimeline-module__HazpYW__nodeCircle",
  "nodeLabel": "CareerProgressionTimeline-module__HazpYW__nodeLabel",
  "nodeYears": "CareerProgressionTimeline-module__HazpYW__nodeYears",
  "passedNode": "CareerProgressionTimeline-module__HazpYW__passedNode",
  "requirementTag": "CareerProgressionTimeline-module__HazpYW__requirementTag",
  "requirementTags": "CareerProgressionTimeline-module__HazpYW__requirementTags",
  "requirementsLabel": "CareerProgressionTimeline-module__HazpYW__requirementsLabel",
  "responsibilityList": "CareerProgressionTimeline-module__HazpYW__responsibilityList",
  "salaryAmount": "CareerProgressionTimeline-module__HazpYW__salaryAmount",
  "salaryBar": "CareerProgressionTimeline-module__HazpYW__salaryBar",
  "salaryBarFill": "CareerProgressionTimeline-module__HazpYW__salaryBarFill",
  "salaryBars": "CareerProgressionTimeline-module__HazpYW__salaryBars",
  "salaryChart": "CareerProgressionTimeline-module__HazpYW__salaryChart",
  "salaryLabel": "CareerProgressionTimeline-module__HazpYW__salaryLabel",
  "skillTag": "CareerProgressionTimeline-module__HazpYW__skillTag",
  "skillTags": "CareerProgressionTimeline-module__HazpYW__skillTags",
  "timeToReach": "CareerProgressionTimeline-module__HazpYW__timeToReach",
  "timelineContainer": "CareerProgressionTimeline-module__HazpYW__timelineContainer",
  "timelineNode": "CareerProgressionTimeline-module__HazpYW__timelineNode",
  "timelineNodes": "CareerProgressionTimeline-module__HazpYW__timelineNodes",
  "timelineProgress": "CareerProgressionTimeline-module__HazpYW__timelineProgress",
  "timelineTrack": "CareerProgressionTimeline-module__HazpYW__timelineTrack",
  "toggleIcon": "CareerProgressionTimeline-module__HazpYW__toggleIcon",
});
